import type { KieModelConfig, StatusMapping } from './types';
import { googleConfigs } from './configs/google';
import { klingConfigs } from './configs/kling';
import { volcengineConfigs } from './configs/volcengine';
import { alibabaConfigs } from './configs/alibaba';
import { viduConfigs } from './configs/vidu';

/**
 * KIE API 路径配置（所有模型统一使用）
 */
export const kieApiPaths = {
    /** 创建任务 API 路径 */
    createTask: '/api/v1/jobs/createTask',
    /** 轮询任务 API 路径 */
    pollTask: '/api/v1/jobs/recordInfo',
};

/**
 * KIE 状态映射配置（所有模型统一使用）
 */
export const kieStatusMapping: StatusMapping = {
    /** 任务 ID 字段路径 */
    taskIdPath: 'data.taskId',
    /** 状态字段路径 */
    statePath: 'data.state',
    /** 成功状态值 */
    success: ['success'],
    /** 失败状态值 */
    failed: ['fail'],
    /** 处理中状态值 */
    processing: ['processing'],
    /** 视频 URL 字段路径 */
    videoUrlPath: 'data.resultJson',
    /** 错误信息字段路径 */
    errorPath: 'data.failMsg',
};

/**
 * 模型配置映射
 */
export const kieModelConfigs: Record<string, KieModelConfig> = {
    ...googleConfigs,
    ...klingConfigs,
    ...volcengineConfigs,
    ...alibabaConfigs,
    ...viduConfigs,
};
